import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * A video.js Component for the 'next item' button
 * @param player {Object} A VideoJS player instance.
 * @param options {Object} An object containing options to be passed to this component.
 */
export default class PlaylistBackButton extends Button {
  constructor(player, options) {
    super(player, options);

    this.addClass('vjs-menu-button');
    this.addClass('vjs-playlist-previous-button');
    this.addClass('vjs-icon-previous-item');
    this.controlText(player.localize('Previous Video'));
  }

  handleClick() {
    try {
      this.player_.playlist.previous();
    } catch (e) {
      videojs.error(e);
    }
  }
}
